import React from "react";
import { Table, Typography } from "antd";

const { Text, Title } = Typography;

const columns = [
    {
        title: "Name",
        dataIndex: "name",
    },
    {
        title: "Penalty / Fee",
        dataIndex: "penaltyAndFee",
    },
    {
        title: "Payment Due At",
        dataIndex: "paymentDueAt",
    },

    {
        title: "Calculation Type",
        dataIndex: "calculationType",
    },
    {
        title: "Due",
        dataIndex: "due",
    },
    {
        title: "Paid",
        dataIndex: "paid",
    },
    {
        title: "Waive",
        dataIndex: "waive",
    },
    {
        title: "Oustanding",
        dataIndex: "outstanding",
    },
    {
        title: "Actions",
        dataIndex: "actions",
    }
];

const Charges = (props) => {
    const { chargesList } = props;
    return <Table columns={columns} dataSource={chargesList} />;
};

export default Charges;
